import { init as initApm, createTracer } from '@elastic/apm-rum/dist/es/opentracing';

export default (config) => {
  const sampleRateFloat = parseFloat(config.sampleRatePercentage) / 100;
  const customConfig = {
    pageLoadTransactionName: config.pageLoadTransactionName || window.location.pathname,
    active: Math.random() < sampleRateFloat
  };
  const completeConfig = Object.assign({}, config, customConfig);
  const elasticApm = initApm(completeConfig);

  return createTracer(elasticApm);
};
